export default __webpack_public_path__ + "static/media/350.025fd6a9.png";